/* PAWSNOVA add-on offer: refresh display after cart updates; no price writes. */
(() => {
  if (customElements.get('paws-cart-addon-offer')) return;
  class PawsCartAddonOffer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.scheduleRefresh = () => {
        this.hidden = true;
        clearTimeout(this.refreshTimer);
        this.request?.abort();
        this.refreshTimer = setTimeout(() => this.refresh(), 100);
      };
      this.onPageShow = (event) => {
        if (event.persisted) {
          this.querySelectorAll('button[type="submit"]').forEach((button) => { button.disabled = false; });
          this.scheduleRefresh();
        }
      };
      this.onSubmit = (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.matches('.cart-addon-offer__form')) return;
        const button = form.querySelector('button[type="submit"]');
        if (button) button.disabled = true;
      };
      this.addEventListener('submit', this.onSubmit);
      document.addEventListener('cart:updated', this.scheduleRefresh);
      window.addEventListener('pageshow', this.onPageShow);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.scheduleRefresh);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.refreshTimer);
      this.request?.abort();
      this.unsubscribe?.();
      this.removeEventListener('submit', this.onSubmit);
      document.removeEventListener('cart:updated', this.scheduleRefresh);
      window.removeEventListener('pageshow', this.onPageShow);
      this.initialized = false;
    }
    async refresh() {
      const sectionId = this.dataset.sectionId;
      if (!sectionId) return;
      this.request?.abort();
      const controller = new AbortController();
      this.request = controller;
      try {
        const url = new URL(window.location.href);
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', sectionId);
        const response = await fetch(url.toString(), {
          credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Add-on section refresh failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const updated = html.getElementById(this.id);
        if (!updated || this.request !== controller || !this.isConnected) return;
        this.innerHTML = updated.innerHTML;
        this.hidden = false;
      } catch (error) {
        // Keep stale offer prices hidden; the main cart and checkout remain usable.
        if (error.name !== 'AbortError') this.hidden = true;
      }
    }
  }
  customElements.define('paws-cart-addon-offer', PawsCartAddonOffer);
})();
